/**
 * Human-readable byte formatter. Uses platform-native `Intl.NumberFormat`
 * with byte units — handles localization and unit scaling (B / KB / MB /
 * GB / TB / etc.) without an external dependency.
 *
 * Falls back to the raw number as a string if the runtime doesn't support
 * `style: "unit"` + `unit: "byte"` (pre-2021 environments). Anything that
 * old shouldn't be hitting this code path; the fallback exists only so
 * the call never throws.
 */
const byteFormatter = (() => {
  try {
    return new Intl.NumberFormat("en", {
      notation: "compact",
      style: "unit",
      unit: "byte",
      unitDisplay: "narrow",
    });
  } catch {
    return null;
  }
})();

export const formatBytes = (bytes: number): string =>
  byteFormatter ? byteFormatter.format(bytes) : String(bytes);
